export const FONTS = {
  display: { label: "Bricolage (bold sans)", css: "'Bricolage Grotesque', sans-serif" },
  serif: { label: "Instrument (elegant serif)", css: "'Instrument Serif', serif" },
  playfair: { label: "Playfair (classic serif)", css: "'Playfair Display', serif" },
  manrope: { label: "Manrope (clean sans)", css: "'Manrope', sans-serif" },
  bebas: { label: "Bebas (tall caps)", css: "'Bebas Neue', sans-serif" },
  mono: { label: "JetBrains (typewriter)", css: "'JetBrains Mono', monospace" },
};

export const SWATCHES = ["#0A0A0A", "#FFFFFF", "#E62314", "#57534E", "#ECEAE6", "#FBF9F5", "#0A66C2", "#F5B800"];

export const WIDTHS = { full: "Full width", "2/3": "Two thirds", "1/2": "Half", "1/3": "One third" };
export const WIDTH_CLASS = { full: "md:col-span-6", "2/3": "md:col-span-4", "1/2": "md:col-span-3", "1/3": "md:col-span-2" };
export const PAD = { none: "0", s: "1rem", m: "2rem", l: "4rem" };
export const RATIOS = { original: "Original shape", square: "Square", portrait: "Portrait", landscape: "Landscape", wide: "Wide" };
export const RATIO_CLASS = { original: "", square: "aspect-square", portrait: "aspect-[3/4]", landscape: "aspect-[4/3]", wide: "aspect-video" };

const uid = () => Math.random().toString(36).slice(2, 10);
const base = { width: "full", align: "left", bg: "", pad: "none" };

export const BLOCK_TYPES = {
  heading: { label: "Heading", make: () => ({ ...base, text: "Your heading", font: "display", size: 56, color: "#0A0A0A", weight: 800, italic: false }) },
  text: { label: "Text", make: () => ({ ...base, text: "Write something here.", font: "manrope", size: 18, color: "#2A2928", weight: 400, italic: false }) },
  image: { label: "Photo", make: () => ({ ...base, media: null, ratio: "original", radius: 0, caption: "", link: "" }) },
  video: { label: "Video", make: () => ({ ...base, media: null, ratio: "wide", autoplay: false, controls: true }) },
  gallery: { label: "Gallery", make: () => ({ ...base, items: [], columns: 3, ratio: "square", gap: 12 }) },
  button: { label: "Button", make: () => ({ ...base, label: "Find out more", link: "/", variant: "underline", color: "#0A0A0A" }) },
  spacer: { label: "Space", make: () => ({ ...base, height: 64 }) },
};

export const newBlock = (type) => ({ id: uid(), type, ...BLOCK_TYPES[type].make() });
export const cloneBlock = (b) => ({ ...JSON.parse(JSON.stringify(b)), id: uid() });
